import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { refreshCertification } from '../../utils/certificationCache';
import { AppContext } from '../../App';

// Define interface for custom success and error messages
interface UseAddFieldHookParams {
  successMessage?: string;
  errorMessage?: string;
  trainingSetId?: string;
}

export const useAddFieldHook = ({
  successMessage = 'Field added successfully.',
  errorMessage = 'An error occurred while adding the field.',
  trainingSetId,
}: UseAddFieldHookParams = {}) => {
  const glynt = useGlynt();
  const cache = useQueryClient();
  const { setToast } = useContext(AppContext);

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (data: any) => (await glynt).fields.create(data),

    onSuccess: () => {
      refreshCertification(cache, trainingSetId);
      cache.invalidateQueries({
        queryKey: ['fields']
      });
      setToast({
        variant: 'success',
        open: true,
        message: successMessage,
      });
    },

    onError: (error: Error) => {
      setToast({
        variant: 'error',
        open: true,
        message: error.message || errorMessage,
      });
    }
  });

  return { addField: mutateAsync, isAdding: isPending };
};
